import React from 'react';

import { Button } from 'components/Button';

import { Container, Controls, DescriptionContainer, IllustrationContainer, Title, Subtitle } from './styles';

export default function PageFactory(
  Illustration: React.FunctionComponent,
  title: string,
  subtitles: React.ReactNode[],
  // Embedded surfaces (e.g. the mobile WebView) hide the "Back to Home" control so the
  // user can't leave the locked flow into the rest of the workspace.
  hideControls = false
): React.ReactNode {
  return (
    <Container>
      <IllustrationContainer>
        <Illustration />
      </IllustrationContainer>
      <DescriptionContainer>
        <Title>{title}</Title>
        {subtitles.map((subtitle, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <Subtitle key={index}>{subtitle}</Subtitle>
        ))}
        {!hideControls && (
          <Controls>
            <Button variant="contained" href="/">
              Back to Home
            </Button>
          </Controls>
        )}
      </DescriptionContainer>
    </Container>
  );
}
